// Tabs + quantity helpers (scoped to this section instance)
(function () {
  var root = document.getElementById("shopify-section-{{ section.id }}");
  if (!root) return;

  // Tabs behavior
  var tabsWrap = root.querySelector(".npm-tabs");
  if (tabsWrap) {
    var tabs = tabsWrap.querySelectorAll(".npm-tab");
    var panels = tabsWrap.querySelectorAll(".npm-panel");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var target = tab.getAttribute("data-tab");

        tabs.forEach(function (t) {
          t.classList.remove("is-active");
          t.setAttribute("aria-selected", "false");
        });
        panels.forEach(function (p) {
          p.classList.remove("is-active");
        });

        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");

        var panel = tabsWrap.querySelector(
          '.npm-panel[data-panel="' + target + '"]',
        );
        if (panel) panel.classList.add("is-active");
      });
    });
  }

  // Quantity buttons (fallback form)
  var qtyMinus = root.querySelector("[data-qty-minus]");
  var qtyPlus = root.querySelector("[data-qty-plus]");
  var qtyInput = root.querySelector(".npm-qty__input");

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener("click", function () {
      var v = parseInt(qtyInput.value || "1", 10);
      qtyInput.value = Math.max(1, v - 1);
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });

    qtyPlus.addEventListener("click", function () {
      var v = parseInt(qtyInput.value || "1", 10);
      qtyInput.value = Math.max(1, v + 1);
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
})();

new ScrollClassToggle({
  trigger: '.npm-buy',
  target: '.fly-buy-buttons',
  className: 'show',
});